import { useContext, useRef } from "react";
import { useTranslation } from "react-i18next";

import { Toast } from "primereact/toast";
import { InputText } from "primereact/inputtext";
import { Dialog } from "primereact/dialog";
import { Editor } from "primereact/editor";

import moment from "moment";

import { SmsLogContext } from "components/sms-log/SmsLogContext";
import { Button } from "primereact/button";

export const SmsLogEditor = () => {
    const toast = useRef(null);
    const { t } = useTranslation(["sms-log", "common"]);

    const smsLogContext = useContext(SmsLogContext);
    const { smsLog, setSmsLog, smsLogDialog, setSmsLogDialog } = smsLogContext;

    const logStatus = [
        { label: t("not_send"), value: "NOT_SEND" },
        { label: t("sent_success"), value: "SENT_SUCCESS" },
        { label: t("sent_failure"), value: "SENT_FAILURE" },
    ];

    const hideDialog = () => {
        setSmsLogDialog(false);
    };

    const formatDateInput = (data) => {
        if (data) {
            const year = data?.substr(0, 4);
            const month = data?.substr(5, 2);
            const day = data?.substr(8, 2);
            const hour = data?.substr(11, 2);
            const minute = data?.substr(14, 2);
            const second = data?.substr(17, 2);

            return `${day}/${month}/${year} ${hour}:${minute}:${second}`;
        }
        return null;
    };

    return (
        <>
            <Toast ref={toast} />

            <Dialog visible={smsLogDialog} style={{ width: "50%" }} header={t("smsLog.titleDetail")?.toUpperCase()} modal className="p-fluid text-center" onHide={hideDialog}>
                <div className="formgrid">
                    <div className="grid text-left">
                        <div className="col-12">
                            <div className="grid">
                                {/* sô điện thoại */}
                                <div className="field col-12 md:col-3">
                                    <label htmlFor="phoneNumber">{t("phoneNumber")}</label>
                                    <InputText id="phoneNumber" value={smsLog?.phoneNumber} readOnly />
                                </div>
                                {/* trạng thái */}
                                <div className="field col-12 md:col-3">
                                    <label htmlFor="status">{t("status")}</label>
                                    <InputText id="status" value={logStatus.find((g) => g.value === smsLog?.status)?.label} readOnly />
                                </div>

                                {/* ngày tạo */}
                                <div className="field col-12 md:col-3">
                                    <label htmlFor="createdDate">{t("createdDate")}</label>
                                    <InputText id="createdDate" value={formatDateInput(smsLog?.createdDate)} readOnly />
                                </div>
                                {/* ngày sửa */}
                                <div className="field col-12 md:col-3">
                                    <label htmlFor="modifiedDate">{t("modifiedDate", { ns: "common" })}</label>
                                    <InputText id="modifiedDate" value={formatDateInput(smsLog?.updatedDate)} readOnly />
                                </div>
                            </div>
                            <div className="grid">
                                {/* nội dung */}
                                <div className="field col-12">
                                    <label htmlFor="content">{t("content")}</label>
                                    <Editor id="content" showHeader={false} style={{ height: "100px" }} value={smsLog?.content} readOnly />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="grid">
                    <div className="col-12">
                        {/* close */}
                        <Button
                            style={{
                                width: "max-content",
                            }}
                            className="mr-2 p-button-danger"
                            label={t("close", { ns: "common" })}
                            icon="pi pi-times"
                            onClick={hideDialog}
                        />
                    </div>
                </div>
            </Dialog>
        </>
    );
};
